import { render, staticRenderFns } from "./RichTextBox.vue?vue&type=template&id=43e8c521&scoped=true"
import script from "./RichTextBox.vue?vue&type=script&lang=js"
export * from "./RichTextBox.vue?vue&type=script&lang=js"
import style0 from "./RichTextBox.vue?vue&type=style&index=0&id=43e8c521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8c521",
  null
  
)

export default component.exports